export default __webpack_public_path__ + "static/media/peugot408.038173be.png";